import * as React from "react";

import "./addresses-section.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {plural}         from "@Common/ui-components/language/plural";

import {SearchInput}          from "../../../../../../../common/design2/search-input/search-input";
import {MLAddressTableFilter} from "../../../../../../ml-addresses-table/ml-address-table-filter";
import {MLAddressesTable}     from "../../../../../../ml-addresses-table/ml-addresses-table";

export const AddressesSection = ({addresses, entityId, next}) => cs(

    ["filter", (_, next) => UseState({next})],
    ["match", ({filter}, next) => next(MLAddressTableFilter({search: filter.value}))],
    ["filteredRecords", ({match}, next) => next(addresses.value?.filter(match))],

    ({filter, filteredRecords}) => next({
        searchInput: SearchInput({
            state: filter,
            placeholder: "Search List",
            text: filter.value && <>Found <b>{filteredRecords.length}</b> {plural("address", filteredRecords.length)}</>,
        }),
        renderTable: ({loading, countryCode, mlId}) => cs(
            consumeContext("apis"),
            ({apis}) => (
                MLAddressesTable({
                    data: filteredRecords,
                    loading,
                    countryCode,
                    onEdit: async (edited) => {
                        const result = await apis.next.mailing.updateMailingAddress(edited, entityId);
                        addresses.change((_) => _.map((r1) => r1.idPrimary !== edited.idPrimary ? r1 : {
                            ...r1,
                            ...result.address,
                            status: result.status,
                            validationMessage: result.validationMessage,
                        } ));
                        return result;
                    },
                    onAdd: async (newAddress) => {
                        const result = await apis.next.mailing.addMailingAddress(newAddress, entityId, mlId);
                        addresses.change((_) => [
                            ..._,
                            {
                                idPrimary: result.addressId,
                                idList: mlId,
                                ...result.address,
                                status: result.status,
                            },
                        ]);
                        return result;
                    },
                    onDelete: async (r) => {
                        await apis.next.mailing.deleteMailingAddress(r);
                        addresses.change((_) => _.filter((r1) => r1.idPrimary !== r.idPrimary));
                    },
                })
            ),
        ),
    }),
);
